import { Package } from 'lucide-react';

import { WidgetLayout } from '@/_containers';
import { dashboardWidgetsPermissionConfig } from '@/_shared';

export function Layout({
  children,
  className,
  fallback,
}: {
  children: React.ReactNode;
  className?: string;
  fallback?: React.ReactNode;
}) {
  return (
    <WidgetLayout
      title={dashboardWidgetsPermissionConfig['top_competitors_snapshot'].name}
      icon={Package}
      viewAllLink="/competitors"
      viewAllText="View All Competitors"
      className={className}
      fallback={fallback}
      bodyClassName="3xl:pr-1 pr-0.5"
      descriptionClassName="max-h-[480px] pr-4 overflow-y-auto"
    >
      {children}
    </WidgetLayout>
  );
}
